import type { FaireProductEntity } from "../../entity_types/product";

export const fable_home_2: FaireProductEntity = {
  token: "fable-home-2",
  type: "product",
  name: "Ceramic Vase",
  brandName: "Fable Home",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/1f0514e2815491254543d8c9831d3dfaa02066c637bdcf41f139c78ba01a1fb2.webp",
  priceDollars: 65,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/4c38e4ee3cce8e1ab8ce4c00ccb9fff7264b2c9a3b219f238f775e86ea3cc12c.webp",
  weight: 3,
  dimensions: {
    width: 8,
    height: 12,
    depth: 8,
  },
  description: "Handcrafted ceramic vase for fresh or dried arrangements.",
  categoryTokens: ["cat_accessories"],
  tags: ["ceramic", "home", "vase", "decor"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
